import React, { useState, useEffect, useMemo, useCallback } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import Sidebar from '../../../Components/Sidebar/Sidebar';
import axios from 'axios';
import filtrarUsuarioIA from '../../../../FuncoesGerais/filtrarUsuarioIA';
import '../../styles/inventario.css';
import './ListaHardware.css';
import ListaHardwares from '../../components/ListaHardware/ListaHardware';
import InventarioToolbar from '../../components/InventarioToolbar/InventarioToolbar';
import InventoryDashboard from '../../components/InventoryDashboard/InventoryDashboard';
import InventarioDrawer from '../../components/InventarioDrawer/InventarioDrawer';
import InventarioFormDrawer from '../../components/InventarioFormDrawer/InventarioFormDrawer';
import HardwareFotosCondicaoModal from '../../components/HardwareFotosCondicaoModal/HardwareFotosCondicaoModal';
import { getStatusKey } from '../../components/StatusBadge/StatusBadge';
import verificandoToken from '../../../../FuncoesGerais/VerificarToken';
import verificandoApp from '../../../../FuncoesGerais/verificaApp';
import { ensureProtocol } from '../../../../config/backend';

function Hardwares() {
    const history = useHistory();
    const location = useLocation();
    const editIdFromState = location.state?.editId;

    const verificar = async () => {
        const resultado = await verificandoApp("ATENDENTE");
        if (!resultado) history.push("/");
    };

    const [data, setData] = useState([]);
    const [descr, setDescr] = useState('');
    const [filterStatus, setFilterStatus] = useState('');
    const [formDrawerOpen, setFormDrawerOpen] = useState(false);
    const [equipamentos, setEquipamentos] = useState([]);
    const [selected, setSelected] = useState('');
    const [codHar, setCodHar] = useState('');
    const [serEqp, setSerEqp] = useState('');
    const [patEqp, setPatEqp] = useState('');
    const [desEqp, setDesEqp] = useState('');
    const [sitEqp, setSitEqp] = useState('');
    const [obsEqp, setObsEqp] = useState('');
    const [updIns, setUpdIns] = useState('I');
    const [mensagem, setMensagem] = useState('');
    const [showDocModal, setShowDocModal] = useState(false);
    const [codHarDoc, setCodHarDoc] = useState('');
    const [labelHarDoc, setLabelHarDoc] = useState('');
    const [desHisDoc, setDesHisDoc] = useState('');
    const [mensagemDoc, setMensagemDoc] = useState('');
    const [loadingDoc, setLoadingDoc] = useState(false);
    const [drawerOpen, setDrawerOpen] = useState(false);
    const [drawerAssetId, setDrawerAssetId] = useState(null);
    const [drawerRefreshTrigger, setDrawerRefreshTrigger] = useState(0);
    const [showLinkModal, setShowLinkModal] = useState(false);
    const [linkCodHar, setLinkCodHar] = useState('');
    const [linkUsuarios, setLinkUsuarios] = useState([]);
    const [linkSelectedUsu, setLinkSelectedUsu] = useState('');
    const [linkObs, setLinkObs] = useState('');
    const [linkLoading, setLinkLoading] = useState(false);
    const [linkMsg, setLinkMsg] = useState('');
    const [showUnlinkModal, setShowUnlinkModal] = useState(false);
    const [unlinkCodHar, setUnlinkCodHar] = useState('');
    const [unlinkAssignment, setUnlinkAssignment] = useState(null);
    const [unlinkObs, setUnlinkObs] = useState('');
    const [unlinkLoading, setUnlinkLoading] = useState(false);
    const [unlinkMsg, setUnlinkMsg] = useState('');
    const [showFotosModal, setShowFotosModal] = useState(false);
    const [fotosCodHar, setFotosCodHar] = useState('');
    const [fotosLabel, setFotosLabel] = useState('');

    const pegarEquipamento = async () => {
        verificandoToken();
        try {
            const token = localStorage.getItem('token');
            const response = await axios.get(ensureProtocol(localStorage.getItem("ipBackend2")) + "/equipamentos/lista", { headers: { Authorization: `${token}` } });
            const raw = Array.isArray(response.data) ? response.data : [];
            const normalized = raw.map((e) => ({
                codeqp: e.codeqp ?? e.CODEQP,
                nomeqp: (e.nomeqp ?? e.NOMEQP ?? '').toString(),
                deseqp: (e.deseqp ?? e.DESEQP ?? '').toString(),
                layeqp: (e.layeqp ?? e.LAYEQP ?? '').toString()
            }));
            setEquipamentos(normalized);
        } catch (e) {
            console.error(e);
            setEquipamentos([]);
        }
    };

    const buscandoHardware = async (id) => {
        if (!id) return;
        verificandoToken();
        try {
            const token = localStorage.getItem('token');
            const response = await axios.get(ensureProtocol(localStorage.getItem("ipBackend2")) + "/hardware/espec", {
                headers: { Authorization: `${token}` },
                params: { codHar: id }
            });
            if (response.data.length > 0) {
                const r = response.data[0];
                setUpdIns('U');
                setCodHar(r.codhar ?? r.CODHAR ?? '');
                setSerEqp((r.sereqp ?? r.SEREQP ?? '').toString());
                setDesEqp((r.deseqp ?? r.DESEQP ?? '').toString());
                setPatEqp((r.pateqp ?? r.PATEQP ?? '').toString());
                setSitEqp((r.siteqp ?? r.SITEQP ?? '').toString());
                setSelected((r.codeqp ?? r.CODEQP ?? '').toString());
            } else {
                setUpdIns('I');
                setCodHar(''); setSerEqp(''); setDesEqp(''); setPatEqp(''); setSitEqp(''); setObsEqp(''); setSelected('');
            }
        } catch (e) { console.error(e); }
    };

    const limparForm = () => {
        setUpdIns('I');
        setCodHar(''); setSerEqp(''); setDesEqp(''); setPatEqp(''); setSitEqp(''); setObsEqp(''); setSelected('');
        setMensagem('');
    };

    const handleEquipamentoChange = (e) => {
        const cod = e.target.value;
        setSelected(cod);
        const eq = equipamentos.find((opt) => String(opt.codeqp ?? opt.CODEQP) === String(cod));
        const layeqp = eq ? (eq.layeqp ?? eq.LAYEQP ?? '').toString() : '';
        setDesEqp(layeqp);
    };

    const inserindoHardware = async () => {
        if (!serEqp.trim()) { setMensagem("Série obrigatória!"); return; }
        if (!desEqp.trim()) { setMensagem("Descrição obrigatória!"); return; }
        if (!patEqp.trim()) { setMensagem("Patrimônio obrigatório!"); return; }
        if (!sitEqp) { setMensagem("Situação obrigatória!"); return; }
        if (sitEqp !== 'A' && !obsEqp.trim()) { setMensagem("Observação obrigatória para esta situação!"); return; }
        setMensagem('');
        verificandoToken();
        const token = localStorage.getItem('token');
        const codEqp = selected || (equipamentos[0] && equipamentos[0].codeqp);
        try {
            if (updIns === 'I') {
                await axios.post(ensureProtocol(localStorage.getItem("ipBackend2")) + "/hardware", { serEqp, patEqp, desEqp, sitEqp, codEqp }, { headers: { Authorization: `${token}` } });
            } else {
                await axios.put(ensureProtocol(localStorage.getItem("ipBackend2")) + "/hardware", { codHar, serEqp, patEqp, desEqp, sitEqp, codEqp, obsEqp }, { headers: { Authorization: `${token}` } });
            }
            limparForm();
            setFormDrawerOpen(false);
            fetchData();
        } catch (e) { setMensagem('Erro ao salvar'); }
    };

    const fetchData = async () => {
        verificandoToken();
        const token = localStorage.getItem('token');
        const baseUrl = ensureProtocol(localStorage.getItem('ipBackend2'));
        try {
            const response = await axios.get(baseUrl + '/hardware', {
                headers: { Authorization: `${token}` },
                params: { descr: descr || ' ' }
            });
            const raw = Array.isArray(response.data) ? response.data : [];
            let lista = raw.map(h => ({
                codhar: h.codhar ?? h.CODHAR,
                codeqp: h.codeqp ?? h.CODEQP,
                sereqp: h.sereqp ?? h.SEREQP ?? '',
                pateqp: h.pateqp ?? h.PATEQP ?? '',
                deseqp: h.deseqp ?? h.DESEQP ?? '',
                siteqp: (h.siteqp ?? h.SITEQP ?? '').toString(),
                comVinculo: Boolean(h.comVinculo ?? h.COMVINCULO)
            }));
            if (lista.length > 0) {
                const comVinculoFromApi = raw.some(h => h.comVinculo === true || h.COMVINCULO === true);
                if (!comVinculoFromApi) {
                    const results = await Promise.allSettled(
                        lista.map((item) =>
                            axios.get(baseUrl + '/vinculacao/hardware', {
                                headers: { Authorization: `${token}` },
                                params: { codHar: item.codhar }
                            }).then((res) => ({ codhar: item.codhar, hasVinculo: res.data && res.data.length > 0 }))
                        )
                    );
                    const vinculoMap = {};
                    results.forEach((r, i) => {
                        if (r.status === 'fulfilled' && r.value && r.value.hasVinculo) vinculoMap[r.value.codhar] = true;
                    });
                    lista = lista.map((item) => ({
                        ...item,
                        comVinculo: Boolean(vinculoMap[item.codhar] || item.comVinculo)
                    }));
                }
            }
            setData(lista);
        } catch (e) { console.error(e); setData([]); }
    };

    useEffect(() => { verificar(); fetchData(); pegarEquipamento(); }, []); // eslint-disable-line react-hooks/exhaustive-deps
    useEffect(() => {
        if (editIdFromState) {
            buscandoHardware(editIdFromState).then(() => setFormDrawerOpen(true));
        }
    }, [editIdFromState]); // eslint-disable-line react-hooks/exhaustive-deps

    const handleEdit = useCallback(async (id) => {
        setDrawerOpen(false);
        await buscandoHardware(id);
        setFormDrawerOpen(true);
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    const openDrawer = useCallback((assetId) => {
        setDrawerAssetId(assetId);
        setDrawerOpen(true);
    }, []);

    const closeDrawer = useCallback(() => {
        setDrawerOpen(false);
        setDrawerAssetId(null);
    }, []);

    const refreshListAndDrawer = useCallback(() => {
        fetchData();
        setDrawerRefreshTrigger((t) => t + 1);
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    const openLinkModal = useCallback(async (codHar) => {
        setLinkCodHar(codHar);
        setLinkSelectedUsu('');
        setLinkObs('');
        setLinkMsg('');
        setShowLinkModal(true);
        verificandoToken();
        const token = localStorage.getItem('token');
        try {
            const response = await axios.get(ensureProtocol(localStorage.getItem('ipBackend2')) + '/usuarios/ativos', { headers: { Authorization: `${token}` } });
            const raw = filtrarUsuarioIA(Array.isArray(response.data) ? response.data : [], 'USRNOMCPL');
            setLinkUsuarios(raw.map((r) => ({ nome: (r.USRNOMCPL ?? r.usrnomcpl ?? '').toString(), sequencia: r.USUSEQ ?? r.ususeq })));
        } catch (e) {
            setLinkUsuarios([]);
        }
    }, []);

    const closeLinkModal = useCallback(() => {
        setShowLinkModal(false);
        setLinkCodHar('');
        setLinkSelectedUsu('');
        setLinkObs('');
        setLinkMsg('');
    }, []);

    const salvarVinculo = async () => {
        if (!linkObs.trim()) { setLinkMsg('Informe a observação.'); return; }
        if (!linkSelectedUsu) { setLinkMsg('Selecione o usuário.'); return; }
        setLinkMsg('');
        setLinkLoading(true);
        verificandoToken();
        const token = localStorage.getItem('token');
        try {
            await axios.post(ensureProtocol(localStorage.getItem('ipBackend2')) + '/vinculacao', { codEqp: linkCodHar, codUsu: linkSelectedUsu, obsVin: linkObs, sitVin: 'A' }, { headers: { Authorization: `${token}` } });
            const desHis = 'Vinculo realizado com usuário:' + linkSelectedUsu + '\n' + linkObs;
            await axios.post(ensureProtocol(localStorage.getItem('ipBackend2')) + '/hishardware', { codHar: linkCodHar, desHis }, { headers: { Authorization: `${token}` } });
            closeLinkModal();
            refreshListAndDrawer();
        } catch (e) {
            setLinkMsg(e.response?.data?.error || 'Erro ao vincular.');
        } finally {
            setLinkLoading(false);
        }
    };

    const openUnlinkModal = useCallback((codHar, assignment) => {
        if (!assignment || !assignment.seqVin) return;
        setUnlinkCodHar(codHar);
        setUnlinkAssignment(assignment);
        setUnlinkObs('');
        setUnlinkMsg('');
        setShowUnlinkModal(true);
    }, []);

    const closeUnlinkModal = useCallback(() => {
        setShowUnlinkModal(false);
        setUnlinkCodHar('');
        setUnlinkAssignment(null);
        setUnlinkObs('');
        setUnlinkMsg('');
    }, []);

    const salvarDesvinculo = async () => {
        if (!unlinkObs.trim()) { setUnlinkMsg('Informe a observação.'); return; }
        if (!unlinkAssignment?.seqVin) return;
        setUnlinkMsg('');
        setUnlinkLoading(true);
        verificandoToken();
        const token = localStorage.getItem('token');
        try {
            const baseUrl = ensureProtocol(localStorage.getItem('ipBackend2')) + '/vinculacao';
            await axios.delete(`${baseUrl}?seqVin=${encodeURIComponent(unlinkAssignment.seqVin)}`, { headers: { Authorization: `${token}` } });
            const desHis = 'Desvinculo realizado com usuário:' + (unlinkAssignment.codUsu ?? '') + '\n' + unlinkObs;
            await axios.post(ensureProtocol(localStorage.getItem('ipBackend2')) + '/hishardware', { codHar: unlinkCodHar, desHis }, { headers: { Authorization: `${token}` } });
            closeUnlinkModal();
            refreshListAndDrawer();
        } catch (e) {
            setUnlinkMsg(e.response?.data?.error || 'Erro ao desvincular.');
        } finally {
            setUnlinkLoading(false);
        }
    };

    const filteredData = useMemo(() => {
        if (!filterStatus) return data;
        return data.filter(h => getStatusKey(h.siteqp, h.comVinculo) === filterStatus);
    }, [data, filterStatus]);

    const openDocModal = (cod, label) => {
        setCodHarDoc(cod ?? '');
        setLabelHarDoc(label ?? `Hardware ${cod}`);
        setDesHisDoc('');
        setMensagemDoc('');
        setShowDocModal(true);
    };

    const closeDocModal = () => {
        setShowDocModal(false);
        setCodHarDoc('');
        setLabelHarDoc('');
        setDesHisDoc('');
        setMensagemDoc('');
    };

    const salvarDocumentacao = async () => {
        if (!desHisDoc.trim()) { setMensagemDoc('Informe a descrição da manutenção.'); return; }
        setMensagemDoc('');
        setLoadingDoc(true);
        verificandoToken();
        const token = localStorage.getItem('token');
        try {
            await axios.post(ensureProtocol(localStorage.getItem("ipBackend2")) + "/hishardware", { codHar: codHarDoc, desHis: desHisDoc }, { headers: { Authorization: `${token}` } });
            closeDocModal();
            refreshListAndDrawer();
        } catch (e) {
            setMensagemDoc('Erro ao salvar. Tente novamente.');
        } finally {
            setLoadingDoc(false);
        }
    };

    const openFotosModal = (codHar, label) => {
        setFotosCodHar(codHar ?? '');
        setFotosLabel(label ?? `#${codHar}`);
        setShowFotosModal(true);
    };

    const closeFotosModal = () => {
        setShowFotosModal(false);
        setFotosCodHar('');
        setFotosLabel('');
    };

    return (
        <div className="app-layout">
            <Sidebar />
            <main className="main-content">
                <div className="container-fluid titulo cadastro-unificado inventario-page">
                    <span className="inventario-page__modulo">Inventário</span>
                    <InventarioToolbar
                        searchValue={descr}
                        onSearchChange={setDescr}
                        onSearch={fetchData}
                        filterStatus={filterStatus}
                        onFilterStatusChange={setFilterStatus}
                        onNovoHardware={() => { limparForm(); setFormDrawerOpen(true); }}
                        showNovoButton
                    />
                    <InventoryDashboard data={data} />
                    <InventarioFormDrawer
                        open={formDrawerOpen}
                        onClose={() => setFormDrawerOpen(false)}
                        title={updIns === 'U' ? 'Editar hardware' : 'Novo hardware'}
                    >
                        <div className="inventario-form-drawer-form">
                            <div className="form-group">
                                <label>Código (edição)</label>
                                <input type="text" onChange={(e) => buscandoHardware(e.target.value)} className="form-control form-control-sm" placeholder="Código para editar" />
                            </div>
                            <div className="form-group">
                                <label>Equipamento</label>
                                <select value={selected} onChange={handleEquipamentoChange} className="form-control form-control-sm">
                                    <option value="">Selecione...</option>
                                    {equipamentos.map(opt => {
                                        const cod = opt.codeqp ?? opt.CODEQP;
                                        const nome = opt.nomeqp ?? opt.NOMEQP ?? '';
                                        return <option key={cod} value={cod}>{nome}</option>;
                                    })}
                                </select>
                            </div>
                            <div className="form-group">
                                <label>Série</label>
                                <input value={serEqp} onChange={(e) => setSerEqp(e.target.value)} className="form-control form-control-sm" placeholder="Número de série" />
                            </div>
                            <div className="form-group">
                                <label>Patrimônio</label>
                                <input value={patEqp} onChange={(e) => setPatEqp(e.target.value)} className="form-control form-control-sm" placeholder="Número do patrimônio" />
                            </div>
                            <div className="form-group">
                                <label>Situação</label>
                                <select value={sitEqp} onChange={(e) => setSitEqp(e.target.value)} className="form-control form-control-sm">
                                    <option value="">Escolher...</option>
                                    <option value="A">Ativo</option>
                                    <option value="M">Em manutenção</option>
                                    <option value="I">Inativo</option>
                                    <option value="R">Roubado</option>
                                    <option value="Q">Quebrado</option>
                                </select>
                            </div>
                            {sitEqp && sitEqp !== 'A' && (
                                <div className="form-group">
                                    <label>Observação</label>
                                    <textarea value={obsEqp} onChange={(e) => setObsEqp(e.target.value)} className="form-control form-control-sm" rows={2} placeholder="Motivo da situação" />
                                </div>
                            )}
                            <div className="form-group">
                                <label>Descrição</label>
                                <textarea value={desEqp} onChange={(e) => setDesEqp(e.target.value)} className="form-control form-control-sm" rows={3} placeholder="Descrição do equipamento" />
                            </div>
                            {mensagem && <div className="alert alert-danger py-2 mb-2 mt-2">{mensagem}</div>}
                            <div className="inventario-form-drawer-form__actions">
                                <button onClick={() => setFormDrawerOpen(false)} type="button" className="btn btn-secondary btn-sm">Cancelar</button>
                                <button onClick={inserindoHardware} type="button" className="btn btn-primary btn-sm">Salvar</button>
                            </div>
                        </div>
                    </InventarioFormDrawer>
                    <ListaHardwares
                        arraysHardware={filteredData}
                        onEdit={handleEdit}
                        onDocumentar={openDocModal}
                        onOpenDrawer={openDrawer}
                    />
                    <InventarioDrawer
                        open={drawerOpen}
                        onClose={closeDrawer}
                        assetId={drawerAssetId}
                        refreshTrigger={drawerRefreshTrigger}
                        onEdit={handleEdit}
                        onDocumentar={openDocModal}
                        onVincular={openLinkModal}
                        onDesvincular={openUnlinkModal}
                        onFotosCondicao={openFotosModal}
                        onRefresh={refreshListAndDrawer}
                    />
                    <HardwareFotosCondicaoModal
                        isOpen={showFotosModal}
                        onClose={closeFotosModal}
                        codHar={fotosCodHar}
                        label={fotosLabel}
                        onSaved={refreshListAndDrawer}
                    />
                    {showDocModal && (
                        <div className="modal show d-block" style={{ background: 'rgba(0,0,0,0.5)' }} tabIndex={-1}>
                            <div className="modal-dialog modal-dialog-centered">
                                <div className="modal-content">
                                    <div className="modal-header">
                                        <h5 className="modal-title">Documentar Manutenção</h5>
                                        <button type="button" className="btn-close" onClick={closeDocModal} aria-label="Fechar" />
                                    </div>
                                    <div className="modal-body">
                                        <p className="mb-2 text-muted small">Hardware: <strong>{labelHarDoc}</strong> (cód. {codHarDoc})</p>
                                        <div className="form-group">
                                            <label>Descrição da manutenção</label>
                                            <textarea value={desHisDoc} onChange={(e) => setDesHisDoc(e.target.value)} className="form-control" rows={4} placeholder="Descreva o que foi feito no equipamento..." />
                                        </div>
                                        {mensagemDoc && <div className="alert alert-danger py-2 mb-0 mt-2">{mensagemDoc}</div>}
                                    </div>
                                    <div className="modal-footer">
                                        <button type="button" className="btn btn-secondary" onClick={closeDocModal}>Cancelar</button>
                                        <button type="button" className="btn btn-primary" onClick={salvarDocumentacao} disabled={loadingDoc}>{loadingDoc ? 'Salvando...' : 'Salvar'}</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                    {showLinkModal && (
                        <div className="modal show d-block" style={{ background: 'rgba(0,0,0,0.5)' }} tabIndex={-1}>
                            <div className="modal-dialog modal-dialog-centered">
                                <div className="modal-content">
                                    <div className="modal-header">
                                        <h5 className="modal-title">Vincular ativo</h5>
                                        <button type="button" className="btn-close" onClick={closeLinkModal} aria-label="Fechar" />
                                    </div>
                                    <div className="modal-body">
                                        <p className="mb-2 text-muted small">Ativo: <strong>#{linkCodHar}</strong></p>
                                        <div className="form-group mb-2">
                                            <label>Usuário</label>
                                            <select className="form-control" value={linkSelectedUsu} onChange={(e) => setLinkSelectedUsu(e.target.value)}>
                                                <option value="">Selecione...</option>
                                                {linkUsuarios.map((u) => (
                                                    <option key={u.sequencia} value={u.sequencia}>{u.nome}</option>
                                                ))}
                                            </select>
                                        </div>
                                        <div className="form-group mb-2">
                                            <label>Observação</label>
                                            <textarea className="form-control" rows={3} value={linkObs} onChange={(e) => setLinkObs(e.target.value)} placeholder="Observação da vinculação" />
                                        </div>
                                        {linkMsg && <div className="alert alert-danger py-2 mb-0">{linkMsg}</div>}
                                    </div>
                                    <div className="modal-footer">
                                        <button type="button" className="btn btn-secondary" onClick={closeLinkModal}>Cancelar</button>
                                        <button type="button" className="btn btn-primary" onClick={salvarVinculo} disabled={linkLoading}>{linkLoading ? 'Salvando...' : 'Vincular'}</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                    {showUnlinkModal && unlinkAssignment && (
                        <div className="modal show d-block" style={{ background: 'rgba(0,0,0,0.5)' }} tabIndex={-1}>
                            <div className="modal-dialog modal-dialog-centered">
                                <div className="modal-content">
                                    <div className="modal-header">
                                        <h5 className="modal-title">Desvincular ativo</h5>
                                        <button type="button" className="btn-close" onClick={closeUnlinkModal} aria-label="Fechar" />
                                    </div>
                                    <div className="modal-body">
                                        <p className="mb-2 text-muted small">Ativo: <strong>#{unlinkCodHar}</strong></p>
                                        <p className="mb-2">Usuário atual: <strong>{unlinkAssignment.nomUsu || unlinkAssignment.codUsu}</strong></p>
                                        <div className="form-group mb-2">
                                            <label>Observação</label>
                                            <textarea className="form-control" rows={3} value={unlinkObs} onChange={(e) => setUnlinkObs(e.target.value)} placeholder="Observação da desvinculação" />
                                        </div>
                                        {unlinkMsg && <div className="alert alert-danger py-2 mb-0">{unlinkMsg}</div>}
                                    </div>
                                    <div className="modal-footer">
                                        <button type="button" className="btn btn-secondary" onClick={closeUnlinkModal}>Cancelar</button>
                                        <button type="button" className="btn btn-primary" onClick={salvarDesvinculo} disabled={unlinkLoading}>{unlinkLoading ? 'Salvando...' : 'Desvincular'}</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </main>
        </div>
    );
}

export default Hardwares;
